// What each page's "waiting for you" badge counts, as one rule apiece.
//
// A page's tab badge and the badge on its sidebar link have to agree, or the
// sidebar says 2 and the page shows 1 and neither is believed. So the rule
// lives here and both read it: the page counts the rows it has loaded, and
// GET /nav/counts (src/api/routes/navCounts.js) counts the same endpoint's
// rows on the server with the same function.

// Approvals › Leave: requests still to decide (or with a change proposed) that
// this person may decide, which the server answers per row as can_decide.
export const leaveAwaitingDecision = (rows) =>
  (rows || []).filter(r => (r.status === 'pending' || r.proposed_change) && r.can_decide).length;

// Approvals › Overtime & allowances: pending claims other than your own.
export const overtimeAwaitingDecision = (rows, meId) =>
  (rows || []).filter(r => r.status === 'pending' && r.person_id !== meId).length;

// Benefits › Change Requests.
export const isBenefitChangePending = (r) => r.status === 'pending';

// HW Requests: awaiting a PMO decision.
export const isHardwarePendingReview = (r) => ['submitted', 'under_review'].includes(r.status);

// Suggestions › Proposals: an AI proposal nobody has accepted or turned down.
export const isSuggestionProposalPending = (s) => s.ai_proposal_status === 'pending';

// My Overtime: hours the time log suggests were overtime, not yet claimed or
// set aside. Read over last month and this one, the window the page shows.
export const isOvertimeSuggestionOpen = (r) => r.status === 'inferred';
export function overtimeSuggestionWindow(now = new Date()) {
  return {
    from: new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1)).toISOString().slice(0, 10),
    to: now.toISOString().slice(0, 10),
  };
}

// Quality Docs: live documents you are asked to acknowledge and have not.
export const qmsUnacknowledged = (docs) =>
  (docs || []).filter(d => d.requires_acknowledgement && d.status === 'live' && !d.my_read).length;

// My List: open notes whose reminder has come round. The bell shows each one;
// the badge says how many are still waiting to be dealt with.
export const isMyListReminderDue = (n, now = new Date()) =>
  !n.done_at && !!n.remind_at && new Date(n.remind_at).getTime() <= now.getTime();
